import styles from "./tag.module.scss";
type BadgeProps = {
  text?: string;
  type?: "text" | "dot" | "icon"; // design system 분류는 number/dot 인데 number 케이스의 경우 숫자가 아닌 문자로 들어오는 케이스도 있어서 text로 변경 + icon 추가
  backgroundColor?: string;
  marginForCustom?: string;
  badgePosition?: "relative" | "absolute";
  badgeLocation?: "top-right" | "top-left" | "bottom-right" | "bottom-left" | "";
  children?: React.ReactNode;
  fontFamily?: string;
};

const Badge = ({
  text,
  type = "text",
  backgroundColor = "#F53F29",
  marginForCustom,
  badgePosition = "absolute",
  badgeLocation = "top-right",
  children,
  fontFamily,
}: BadgeProps) => {
  const paddingXValue = text && text.length > 1 ? 5 : 0;

  return (
    <div
      className={`${styles["badge"]} ${styles[type]} ${badgePosition === "relative" ? "" : styles[badgeLocation]}`}
      style={{
        backgroundColor,
        position: badgePosition,
        padding: type === "text" ? `0 ${paddingXValue}px` : "",
        margin: marginForCustom || "",
        fontFamily: fontFamily || "inherit",
      }}
    >
      {text && type === "text" && <span>{text}</span>}
      {children && children}
    </div>
  );
};

export default Badge;
